const courses = [
  {
    year: "Fall 2025",
    title: "人工智能与生命科学",
    description: "人工智能（AI）正在颠覆生命科学的研究范式，从基因解码到新药研发，<br>从精准医疗到合成生物学，AI与生物学的深度融合正在重塑人类对生命的认知与探索。<br>本课程聚焦AI在生命科学中的前沿应用与实践，通过“理论+案例+实战”三位一体的教学模式，<br>帮助学生掌握跨学科思维与工具，解决生物学中的复杂问题。",
    tableData: [
      {
        index: 1,
        date: '9/15/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['Introduction of AI Biology'],
        key: ['***'],
        Download: [
          {name: 'Introduction', link: 'http://zhanglab.net/files/ppt/fall-2025/1.1-introduction.pdf'},
        ]
      },
      {
        index: 2,
        date: '9/22/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['The Basics of Machine Learning Algorithms'],
        key: ['***'],
        Download: [
          {name: 'Basic Machine Learning', link: 'http://zhanglab.net/files/ppt/fall-2025/1.2-basic-machine-learning.pdf'},
        ]
      },
      {
        index: 3,
        date: '9/29/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['An Initial Understanding of Deep Learning'],
        key: ['***'],
        Download: [
          {name: 'Deep Neural Network', link: 'http://zhanglab.net/files/ppt/fall-2025/1.3.1-deep-neural-network.pdf'},
        ]
      },
      {
        index: 4,
        date: '10/20/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['Deep Learning Networks'],
        key: ['***'],
        Download: [
          {name: 'DL network', link: 'http://zhanglab.net/files/ppt/fall-2025/1.3.2-DL-networks.pdf'},
        ]
      },
      {
        index: 5,
        date: '11/03/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['Review Of Main Biology Fields'],
        key: ['***'],
        Download: [
          {name: 'review of main biology fields', link: 'http://zhanglab.net/files/ppt/fall-2025/1.4-review-of-main-biology-fields.pdf'},
        ]
      },
      {
        index: 6,
        date: '11/10/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['AI In Biology Intersection And Boundary'],
        key: ['***'],
        Download: [
          {name: 'AI in biology Intersection and Boundary', link: 'http://zhanglab.net/files/ppt/fall-2025/1.5-AI-in-biology-Intersection-and-Boundary.pdf'},
        ]
      },
    ],
    instructors: [
      {
        pos: 'Organizer',
        img: require('../assets/course/zhangqiangfeng.jpg'),
        name: '张强锋',
        school: '清华大学'
      },
    ],
    referenceBox: [
      {
        title: 'Bioinformatics',
        content: [
          {title: 'Bioinformatics and Functional Genomics by Jonathan Pevsner'},
          {title: 'MIT course 6.047/6.878: computational biology: genomes, networks, evolution'},
          {title: 'Beginning perl for bioinformatics, O’Reilly'},
          {title: '《生物信息学》（第2版）李霞，雷健波，李亦学等编'}
        ]
      },
      {
        title: 'Linux OS and programming languages',
        content: [
          {title: 'Linux：“鸟哥的Linux私房菜 - 基础学习篇”'},
          {
            title: 'Python/Perl ',
            children: ['（1）《笨办法学 Python》（《Learn Python The Hard Way》）', '（2）《Python编程入门》', '（3）《Beginning Perl for Bioinformatics》']
          },
          {
            title: 'R（or MATLAB）：',
            children: ['（1）Quick R (online)', '（2）《R语言实战》 (《R in action》)']
          },
          {
            title: 'AI',
            children: [
              '（1）人工智能的底层逻辑 (张长水)',
              '（2）人工智能 (姚期智)',
              '（3）机器学习 (周志华)',
              '（4）Deep Learning (Yoshua Bengio)',
              '（5）Dive into Deep Learning (https://zh.d2l.ai)',
            ]
          }
        ]
      }
    ]
  },
  {
    year: "Spring 2025",
    title: "Bioinformatics and Systems Biology",
    description: "",
    tableData: [
      {
        index: 1,
        date: '3/31/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['Introduction to Bioinformatics','Sequence analysis'],
        key: ['***'],
        Download: [
          {name: 'Course Introduction', link: 'http://zhanglab.net/files/ppt/spring-2025/0-courseIntro.pptx'},
          {name: 'Sequence Analysis', link: 'http://zhanglab.net/files/ppt/spring-2025/1-sequenceAnalysis.pptx'}
        ]
      },
      {
        index: 2,
        date: '4/7/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['Structure bioinformatics','Gene function annotation/prediction'],
        key: ['***'],
        Download: [
          {name: 'Structure Analysis', link: 'http://zhanglab.net/files/ppt/spring-2025/2-structureAnalysis.pptx'},
        ]
        },
      {
        index: 3,
        date: '4/14/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['System biology','Computational genomics'],
        key: ['***'],
        Download: [
          {name: 'System Biology', link: 'http://zhanglab.net/files/ppt/spring-2025/4-systemsBiology.pptx'},
          {name: 'Computational Genomics I', link: 'http://zhanglab.net/files/ppt/spring-2025/5-computationalGenomicsI.pptx'}
        ]
      },
      {
        index: 4,
        date: '4/21/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['Computational genomics II','Computational genomics III'],
        key: ['***'],
        Download: [
          {name: 'Computational Genomics II', link: 'http://zhanglab.net/files/ppt/spring-2025/6-computationalGenomicsII.pptx'},
          {name: 'Computational Genomics III', link: 'http://zhanglab.net/files/ppt/spring-2025/7-ComputationalGenomicsIII.pptx'}
        ]
      },
      {
        index: 5,
        date: '4/28/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['Chromatin structure','RNA structure','Single Cell RNA-seq'],
        key: ['***'],
        Download: [
          {name: 'Chromatin structure', link: 'http://zhanglab.net/files/ppt/spring-2025/8-Chromatin.pptx'},
          {name: 'RNA structure', link: 'http://zhanglab.net/files/ppt/spring-2025/9-RNA.pptx'},
          {name: 'Single Cell RNA-seq', link: 'http://zhanglab.net/files/ppt/spring-2025/10-singleCells.pptx'}
        ]
      },
      {
        index: 6,
        date: '5/12/2025',
        lecturer: 'Q.C. Zhang',
        topic: ['Artificial Intelligence','Deep learning','AI revolution for life sciences'],
        key: ['***'],
        Download: [
          {name: 'Artificial Intelligence', link: 'http://zhanglab.net/files/ppt/spring-2025/11-AI.pptx'},
          {name: 'Deep learning', link: 'http://zhanglab.net/files/ppt/spring-2025/12-DL.pptx'},
          {name: 'AI revolution for life sciences', link: 'http://zhanglab.net/files/ppt/spring-2025/13-AI-revolution-for-Life-science-v6.pptx'}
        ]
      }
    ],
    instructors: [
      {
        pos: 'Organizer',
        img: require('../assets/course/zhangqiangfeng.jpg'),
        name: '张强锋',
        school: '清华大学'
      },
    ],
    referenceBox: [
      {
        title: 'Bioinformatics',
        content: [
          {title: 'Bioinformatics and Functional Genomics by Jonathan Pevsner'},
          {title: 'MIT course 6.047/6.878: computational biology: genomes, networks, evolution'},
          {title: 'Beginning perl for bioinformatics, O’Reilly'},
          {title: '《生物信息学》（第2版）李霞，雷健波，李亦学等编'}
        ]
      },
      {
        title: 'Linux OS and programming languages',
        content: [
          {title: 'Linux：“鸟哥的Linux私房菜 - 基础学习篇”'},
          {
            title: 'Python/Perl ',
            children: ['（1）《笨办法学 Python》（《Learn Python The Hard Way》）', '（2）《Python编程入门》', '（3）《Beginning Perl for Bioinformatics》']
          },
          {
            title: 'R（or MATLAB）：',
            children: ['（1）Quick R (online)', '（2）《R语言实战》 (《R in action》)']
          }
        ]
      }
    ]
  },
  {
    year: "2020",
    title: "Bioinformatics and Systems Biology",
    description: "This course is taught by Professor Qiangfeng Cliff Zhang, Professor Wei Zhang and Professor Xuerui Yang.<br/> Cliff mainly teaches the basics of bioinformatics, omics analysis, structural bioinformatics, systems biology,<br/> and the frontiers of bioinformatics and system biology. Wei Zhang mainly teaches the core concepts,<br> principles and methods in evolutionary genomics;Yang mainly teaches Gene regulatory network model for complex diseases",
    tableData: [
      {
        index: 1,
        date: '5/25/2020',
        lecturer: 'Q.C. Zhang',
        topic: ['Introduction to Bioinformatics'],
        key: ['***'],
        Download: []
      },
      {
        index: 2,
        date: '5/26/2020',
        lecturer: 'W. Zhang',
        topic: ['The core concepts, principles and methods in evolutionary genomics (Part 1)'],
        key: ['***'],
        Download: []
      },
      {
        index: 3,
        date: '5/28/2020',
        lecturer: 'W. Zhang',
        topic: ['The core concepts, principles and methods in evolutionary genomics (Part 2)'],
        key: ['***'],
        Download: []
      },
      {
        index: 4,
        date: '5/28/2020',
        lecturer: 'Q.C. Zhang',
        topic: ['Omics data analysis'],
        key: ['***'],
        Download: []
      },
      {
        index: 5,
        date: '5/28/2020',
        lecturer: 'Q.C. Zhang',
        topic: ['Structural bioinformatics'],
        key: ['***'],
        Download: []
      },
      {
        index: 6,
        date: '6/1/2020',
        lecturer: 'Q.C. Zhang',
        topic: ['Basics of Systems Biology'],
        key: ['***'],
        Download: []
      },
      {
        index: 7,
        date: '6/2/2020',
        lecturer: 'Q.C. Zhang',
        topic: ['Frontiers of Bioinformatics and Systems Biology (Part 1)'],
        key: ['***'],
        Download: []
      },
      {
        index: 8,
        date: '6/2/2020',
        lecturer: 'Q.C. Zhang',
        topic: ['Frontiers of Bioinformatics and Systems Biology (Part 2)'],
        key: ['***'],
        Download: []
      },
      {
        index: 9,
        date: '6/4/2020',
        lecturer: 'X.R. Yang',
        topic: ['Gene regulation network model of complex diseases (Part 1)'],
        key: ['***'],
        Download: []
      },
      {
        index: 10,
        date: '6/4/2020',
        lecturer: 'X.R. Yang',
        topic: ['Gene regulation network model of complex diseases (Part 2)'],
        key: ['***'],
        Download: []
      }
    ],
    instructors: [
      {
        pos: 'Organizer',
        img: require('../assets/course/zhangqiangfeng.jpg'),
        name: '张强锋',
        school: '清华大学'
      },
      {
        pos: 'Invited lecturer',
        img: require('../assets/course/zhangwei.jpg'),
        name: '张蔚',
        school: '北京大学'
      },
      {
        pos: 'Invited lecturer',
        img: require('../assets/course/yangxuerui.jpg'),
        name: '杨雪瑞',
        school: '清华大学'
      }
    ],
    referenceBox: [
      {
        title: 'Bioinformatics',
        content: [
          {title: 'Bioinformatics and Functional Genomics by Jonathan Pevsner'},
          {title: 'MIT course 6.047/6.878: computational biology: genomes, networks, evolution'},
          {title: 'Beginning perl for bioinformatics, O’Reilly'},
          {title: '《生物信息学》（第2版）李霞，雷健波，李亦学等编'}
        ]
      },
      {
        title: 'Linux OS and programming languages',
        content: [
          {title: 'Linux：“鸟哥的Linux私房菜 - 基础学习篇”'},
          {
            title: 'Python/Perl ',
            children: ['（1）《笨办法学 Python》（《Learn Python The Hard Way》）', '（2）《Python编程入门》', '（3）《Beginning Perl for Bioinformatics》']
          },
          {
            title: 'R（or MATLAB）：',
            children: ['（1）Quick R (online)', '（2）《R语言实战》 (《R in action》)']
          }
        ]
      }
    ]
  },
]

export default courses
